import { IframeMessage } from '@/constants/iframeMessages';
import { iframeMessenger, type EventData } from '@/services/iframeMessenger';
import { getEventDataForSdkEvents } from './eventDataBuilder';
import type { CheckoutData } from '@/types/checkout';
import type { PaymentMethodEnum } from '@/types/common';

export const notifyOrderSuccess = (eventData: EventData) => {
  iframeMessenger.postMessage(IframeMessage.ORDER_COMPLETED_SUCCESS, eventData);
};

export const notifyOrderFailed = (eventData: EventData) => {
  iframeMessenger.postMessage(IframeMessage.ORDER_COMPLETED_FAILED, eventData);
};

export const notifyCloseCheckout = (eventData: EventData) => {
  iframeMessenger.postMessage(IframeMessage.CLOSE_CHECKOUT, eventData);
};

export const notifyCheckoutOpened = (eventData: EventData) => {
  iframeMessenger.postMessage(IframeMessage.CHECKOUT_OPENED, eventData);
};

export const notifyPaymentIntent = (eventData: EventData) => {
  iframeMessenger.postMessage(IframeMessage.ON_PAYMENT_INTENT, eventData);
};

export const notifyPaymentIntentSuccess = (eventData: EventData) => {
  iframeMessenger.postMessage(IframeMessage.PAYMENT_INTENT_SUCCESS, eventData);
};

export const notifyPaymentIntentFailed = (checkoutData: CheckoutData, paymentMethod?: PaymentMethodEnum) => {
  const eventData = getEventDataForSdkEvents(checkoutData, { paymentMethodName: paymentMethod });
  iframeMessenger.postMessage(IframeMessage.PAYMENT_INTENT_FAILED, eventData);
};

export const notifyOrderCreated = (eventData: EventData) => {
  iframeMessenger.postMessage(IframeMessage.ORDER_CREATED, eventData);
};
